import { ChangeDetectionStrategy, Component } from '@angular/core';

import { ShSimpleInputFieldComponent } from '../simple-input-field/simple-input-field.component';

import { UrlInputValidator } from './url-input.validator';

import { UntypedFormControl } from '@angular/forms';
import { ExtendedBaseProfileField } from '../../../../../core/profiles/entities/extended-profile-field.entity';
import { PartialRecord } from '../../../../../core/records/entities/partial-record.class';

@Component({
    selector: 'sh-url-field',
    templateUrl: '../simple-input-field/simple-input-field.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShUrlInputFieldComponent extends ShSimpleInputFieldComponent {
    init(profileField: ExtendedBaseProfileField, records: PartialRecord[], control: UntypedFormControl): void {
        super.init(profileField, records, control);
        control.addValidators(UrlInputValidator);
    }
}
